import React from "react";
import PropTypes from "prop-types";

import "./app-download-hub.scss";

import MobileAppStoreImage from "../../images/icons/download-apple-app-store.svg";
import MobilePlayStoreImage from "../../images/icons/download-google-play-store.svg";

/**
 * This renders the mobile app download button with its description text.
 *
 * @param {Object} props - The object containing props.
 * @param {string} props.id - required complementary text to detail the id.
 * @param {string} props.url - required store url.
 * @param {string} props.storeBtn - something like "apple" and "google", we could add more stores.
 * @param {string} props.altText - alt text for the image.
 * @param {Object} props.containerStyle - extra styles applied to the div containing the text and anchor.
 * @param {Object} props.anchorStyle - extra styles applied to the anchor element containing the image.
 * @param {Object} props.imgStyle - extra styles applied to the app store image inside the anchor link.
 * @param {string} props.br - border radius applied to the image/icon of the button.
 * @param {string} props.mt - custom margin top for the image/icon of the button.
 * @param {string} props.mb - custom margin bottom for the image/icon of the button.
 * @returns {React.JSX.Element} Returns the JSX component to render
 */
const MobileAppDownloadBtn = ({
  id = "google-play-store",
  url = "/",
  storeBtn = "google",
  altText = "",
  containerStyle = {},
  anchorStyle = {},
  imgStyle = {},
  br = 5, // Border radius
  mt = 0, // Margin top
  mb = 0, // Margin bottom,
  textClass,
  text
}) => {
  let storeTitle = storeBtn === "apple" ? "Apple App Store." : "Google Play Store.";

  let imageSrc = storeBtn === "apple" ? MobileAppStoreImage : MobilePlayStoreImage;

  return (
    <div className="app-download-hub-element-container" style={containerStyle}>
      <a
        id={"wafd-mobile-app-" + id}
        href={url}
        className="mobile-app-download-btn"
        style={anchorStyle}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt={altText}
          src={imageSrc}
          style={{
            ...imgStyle,
            borderRadius: br + "px",
            marginTop: mt + "px",
            marginBottom: mb + "px"
          }}
        />
        <span className="sr-only">{storeTitle}</span>
      </a>
      {text && (
        <div className="app-download-hub-element-text-container">
          <p className={"mb-0 " + textClass}>
            <span dangerouslySetInnerHTML={{ __html: text }} />
          </p>
        </div>
      )}
    </div>
  );
};

export default MobileAppDownloadBtn;

MobileAppDownloadBtn.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  storeBtn: PropTypes.string.isRequired,
  altText: PropTypes.string,
  br: PropTypes.number, //Border radius
  mt: PropTypes.number, //Margin top
  mb: PropTypes.number, //Margin bottom
  anchorStyle: PropTypes.object,
  imgStyle: PropTypes.object,
  textClass: PropTypes.string,
  text: PropTypes.string
};
